import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Fire } from "@phosphor-icons/react";
import confetti from "canvas-confetti";
import { toast } from "sonner";
import client from "../lib/api";

let celebratedThisSession = false;

function maybeCelebrate({ week_count, last_week_count, week_start }) {
  if (week_count <= last_week_count || week_count === 0) return;
  const key = `fp_streak_beat_${week_start}`;
  if (celebratedThisSession || localStorage.getItem(key)) return;
  celebratedThisSession = true;
  localStorage.setItem(key, String(week_count));
  confetti({
    particleCount: 140,
    spread: 80,
    origin: { x: 0.08, y: 0.2 },
    colors: ["#FF5A1F", "#FF9764", "#FFD166", "#ffffff"],
  });
  setTimeout(() => confetti({
    particleCount: 90,
    spread: 100,
    origin: { x: 0.5, y: 0.1 },
    colors: ["#FF5A1F", "#FF9764", "#34d399"],
  }), 350);
  toast.success("NEW WEEKLY RECORD", {
    description: `${week_count} lead${week_count === 1 ? "" : "s"} this week — you just beat last week's ${last_week_count}. Keep the streak alive!`,
    duration: 12000,
    style: { border: "1px solid #FF5A1F", background: "#1a0d05", color: "#FFD9C4" },
  });
}

export const LeadHotStreak = ({ className = "", compact = false }) => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await client.get("/admin/lead-hot-streak");
        if (cancelled) return;
        setStats(data);
        maybeCelebrate(data);
      } catch {
        /* silent */
      }
    };
    load();
    const t = setInterval(load, 120000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!stats) return null;
  const { week_count, last_week_count } = stats;
  const delta = week_count - last_week_count;
  const hot = week_count > 0;

  return (
    <button
      data-testid="lead-hot-streak"
      onClick={() => navigate("/app/inbox")}
      title="Leads since Monday — tap to open Inbox"
      className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold transition-colors ${
        hot
          ? "border-[#FF5A1F]/50 bg-[#FF5A1F]/10 text-[#FF9764] hover:bg-[#FF5A1F]/20"
          : "border-white/10 bg-white/[0.03] text-neutral-500 hover:text-neutral-300"
      } ${className}`}
    >
      <Fire size={13} weight={hot ? "fill" : "regular"} color={hot ? "#FF5A1F" : "currentColor"} />
      <span data-testid="lead-hot-streak-count">
        {week_count} lead{week_count === 1 ? "" : "s"}{compact ? "" : " this week"}
      </span>
      {delta !== 0 && (
        <span
          data-testid="lead-hot-streak-delta"
          className={delta > 0 ? "text-emerald-400" : "text-neutral-500"}
        >
          {delta > 0 ? `▲${delta}` : `▼${Math.abs(delta)}`}
        </span>
      )}
    </button>
  );
};
